import { useReactiveVar } from '@apollo/client'
import LoadingBackdrop from 'components/loadingBackdrop/LoadingBackdrop'
import React, { FC } from 'react'
import { listingPageReactiveVar } from './listingPageReactiveVar'

const ProductListingLoading: FC = () => {
    const { isLoading } = useReactiveVar(listingPageReactiveVar)

    return <LoadingBackdrop isVisible={isLoading} />
}

export default ProductListingLoading
